import { memo, type ReactElement } from 'react'

interface SectionHeadingProps {
  text: string
}
function SectionHeading ({ text }: SectionHeadingProps): ReactElement {
  return (
    <h3 className="text-gray-400 font-semibold">{text}</h3>
  )
}

export default memo(SectionHeading)
